import moment from 'moment'

const dataVendaSeteDias = moment()
.subtract(7, 'days')
.format('YYYY-MM-DD')
const dataVendaMesAtual = moment().format('YYYY-MM-01')
const dataVendaMesPassadoInicio = moment().subtract(1, 'month').format('YYYY-MM-01')
const dataVendaMesPassadoFim = moment().subtract(1, 'month').endOf('month').format('YYYY-MM-DD')
const dataVendaAnoAtual = moment().format('YYYY-01-01')
const dataVendaHoje = moment().format('YYYY-MM-DD')

export default [
  {
    url: '/dashboard',
    name: 'dashboard',
    tagColor: 'warning',
    icon: 'HomeIcon',
    i18n: 'Dashboard'
  },
  {
    header: 'Assinaturas',
    icon: 'PackageIcon',
    items: [
      {
        url: '/assinaturas/todas',
        name: 'assinaturas-todas',
        i18n: 'Todas',
        icon: 'RotateCwIcon'
      }
    ]
  },
  {
    header: 'Vendas',
    icon: 'PackageIcon',
    items: [
      {
        url: `/vendas/todas?status=Pago,Cancelada,Cancelada+Parcialmente&created_at.start=${dataVendaHoje}&created_at.end=${dataVendaHoje}`,
        name: 'vendas-todas',
        i18n: 'Hoje',
        icon: 'ShoppingCartIcon'
      },
      {
        url: `/vendas/ultimos-7-dias?status=Pago,Cancelada,Cancelada+Parcialmente&created_at.start=${dataVendaSeteDias}&created_at.end=${dataVendaHoje}`,
        name: 'vendas-ultimos-7-dias',
        i18n: 'Últimos 7 Dias',
        icon: 'CalendarIcon'
      },
      {
        url: `/vendas/mes-atual?status=Pago,Cancelada,Cancelada+Parcialmente&created_at.start=${dataVendaMesAtual}&created_at.end=${dataVendaHoje}`,
        name: 'vendas-mes-atual',
        i18n: 'Mês Atual',
        icon: 'CalendarIcon'
      },
      {
        url: `/vendas/mes-passado?status=Pago,Cancelada,Cancelada+Parcialmente&created_at.start=${dataVendaMesPassadoInicio}&created_at.end=${dataVendaMesPassadoFim}`,
        name: 'vendas-mes-passado',
        i18n: 'Mês Passado',
        icon: 'CalendarIcon'
      },
      {
        url: `/vendas/ano-atual?status=Pago,Cancelada,Cancelada+Parcialmente&created_at.start=${dataVendaAnoAtual}&created_at.end=${dataVendaHoje}`,
        name: 'vendas-ano-atual',
        i18n: 'Ano Atual',
        icon: 'CalendarIcon'
      },
      {
        url: '/vendas/canceladas?status=Cancelada',
        name: 'vendas-canceladas',
        i18n: 'Cancelada',
        icon: 'XOctagonIcon'
      },
      {
        url: '/vendas/aguardando-pagamento?status=Aguardando+Pagamento',
        name: 'vendas-aguardando-pagamento',
        i18n: 'Aguardando Pagamento',
        icon: 'MinusSquareIcon'
      },
      {
        url: '/vendas/boletos?status=Pago,Cancelada,Cancelada+Parcialmente&payment_method=Boleto',
        name: 'vendas-boletos',
        i18n: 'Boleto',
        icon: 'MenuIcon'
      },
      {
        url: '/vendas/cartoes?status=Pago,Cancelada,Cancelada+Parcialmente&payment_method=Cartão+de+Crédito',
        name: 'vendas-cartoes',
        i18n: 'Cartão de Crédito',
        icon: 'CreditCardIcon'
      },
      {
        url: '/vendas/iugu?status=Pago,Cancelada,Cancelada+Parcialmente&payment_method=Cartão+de+Crédito+(Iugu)',
        name: 'vendas-iugu',
        i18n: 'Iugu',
        icon: 'CreditCardIcon'
      },
      {
        url: '/vendas/paypal-assinaturas?status=Pago,Cancelada,Cancelada+Parcialmente&payment_method=PayPal-Subscription',
        name: 'vendas-paypal-assinaturas',
        i18n: 'PayPal (Assinatura)',
        icon: 'ShoppingCartIcon'
      },
      {
        url: '/vendas/paypal-vendas?status=Pago,Cancelada,Cancelada+Parcialmente&payment_method=PayPal-Order',
        name: 'vendas-paypal-vendas',
        i18n: 'PayPal (Venda)',
        icon: 'ShoppingCartIcon'
      },
      {
        url: '/vendas/transferencias?status=Pago,Cancelada,Cancelada+Parcialmente&payment_method=PicPay',
        name: 'vendas-picpay',
        i18n: 'PicPay',
        icon: 'ShoppingCartIcon'
      },
      {
        url: '/vendas/transferencias?status=Pago,Cancelada,Cancelada+Parcialmente&payment_method=Pix',
        name: 'vendas-pix',
        i18n: 'Pix',
        icon: 'ShoppingCartIcon'
      },
      {
        url: '/vendas/transferencias?status=Pago,Cancelada,Cancelada+Parcialmente&payment_method=Transferência',
        name: 'vendas-transferencias',
        i18n: 'Transferência',
        icon: 'ShoppingCartIcon'
      }
    ]
  },
  {
    header: 'Relatórios',
    icon: 'PackageIcon',
    items: [
      {
        url: '/relatorios/reconciliacao',
        name: 'Reconciliação',
        icon: 'DivideSquareIcon'
      },
      {
        url: '/relatorios/reconciliacao-paypal-assinatura',
        name: 'Reconciliação (Assinaturas PayPal)',
        icon: 'DivideSquareIcon'
      },
      {
        url: '/relatorios/reconciliacao-paypal',
        name: 'Reconciliação (PayPal)',
        icon: 'DivideSquareIcon'
      },
      {
        url: '/relatorios/reconciliacao-iugu',
        name: 'Reconciliação (Iugu)',
        icon: 'DivideSquareIcon'
      },
      {
        url: '/relatorios/devolucoes',
        name: 'Devoluções',
        icon: 'CornerUpRightIcon'
      },
      {
        url: '/relatorios/mobile',
        name: 'Mobile',
        icon: 'SmartphoneIcon'
      }
    ]
  },
  {
    header: 'Lista de Clientes',
    icon: 'PackageIcon',
    i18n: 'Clientes',
    items: [
      {
        url: '/clientes',
        name: 'Todos',
        icon: 'UserIcon'
      }
    ]
  },
  {
    header: 'Painel',
    icon: 'PackageIcon',
    i18n: 'Painel',
    items: [
      {
        url: '/banners',
        name: 'Banners',
        icon: 'BoldIcon'
      },
      {
        url: '/coupons',
        name: 'Cupons',
        icon: 'PercentIcon',
        meta: {
          role: ['admin', 'dev', 'supervisor', 'atendente']
        }
      },
      {
        url: '/videos',
        name: 'Vídeos',
        icon: 'VideoIcon'
      },
      {
        url: '/websitevideos',
        name: 'Vídeos do Site',
        icon: 'VideoIcon'
      },
      {
        url: '/usuarios',
        name: 'Usuários',
        icon: 'UserIcon',
        meta: {
          role: ['admin', 'dev']
        }
      }
    ]
  },
  {
    header: 'Planos',
    icon: 'PackageIcon',
    items: [
      {
        url: '/planos',
        name: 'Planos',
        icon: 'DollarSignIcon'
      }
    ],
    meta: {
      role: ['admin', 'dev', 'supervisor']
    }
  },
  {
    header: 'Comissionamento',
    icon: 'PackageIcon',
    items: [
      {
        url: '/comissoes',
        name: 'Todas',
        icon: 'DollarSignIcon'
      },
      {
        url: '/comissoes/minha',
        name: 'Minha Comissão',
        icon: 'DollarSignIcon'
      }
    ],
    meta: {
      role: ['admin', 'dev', 'supervisor']
    }
  }
]
